import { getColor } from "../../../theme";
import getPillColor from "../colors";
var getBackground = function (_a) {
    var theme = _a.theme, background = _a.background, _b = _a.flavour, flavour = _b === void 0 ? "neutral" : _b, hollow = _a.hollow;
    if (background)
        return;
    var type = hollow ? "hollow" : "background";
    var value = getColor(getPillColor(type, flavour))({ theme: theme });
    return "background-color: " + value + ";";
};
export default getBackground;
